<script>
export default {
  props: {
    show: Boolean,
    idCountry: Number,
    countryPath: String
  },
  data() {
    return {
      countries: [
        {
          id: 1, title: 'Venezuela',
          banks: [{id: 1, name: 'Banesco'}, {id: 2, name: 'Provincial'}, {id: 3, name: 'Mercantil'}],
          observation: 'Puedes enviar dinero a otros bancos, pero debes ingresar los datos Pago móvil al agregar la cuenta de destino en tu perfil web, en el campo llamado “Datos adicionales”, de lo contrario el dinero llegará el día siguiente hábil.'
        },
        {
          id: 3, title: 'Ecuador',
          banks: [{id: 1, name: 'Pichincha'}, {id: 2, name: 'Produbanco'}, {id: 3, name: 'Guayaquil'}],
          observation: 'Al agregar la cuenta de destino en tu perfil web, en el campo llamado “Nº de identificación” debes ingresar el que está asociado a la cuenta bancaria, normalmente, corresponde al Nº del documento de identidad con el cual el destinatario abrió su cuenta bancaria.'
        },
        {
          id: 5, title: 'Brasil',
          banks: [{id: 1, name: 'Caixa'}, {id: 2, name: 'Bradesco'}, {id: 3, name: 'Itaú'}],
          observation: 'Al agregar la cuenta de destino en tu perfil web, en el campo llamado “Datos adicionales” debes ingresar el PIX más el número de agencia. El destinatario puede tener como PIX, su número de teléfono, número de CPF o dirección de correo electrónico, entre otros. El PIX permite que los fondos lleguen a destino de forma inmediata.'
        },
        {
          id: 6, title: 'España',
          banks: [{id: 1, name: 'Caixa'}, {id: 2, name: 'Bankia'}],
          observation: 'Puedes enviar dinero a otros bancos, pero el destinatario debe usar Bizum. Si es así, debes ingresar el número celular que el destinario tenga asociado a Bizum en el campo llamado “Datos adicionales” al agregar la cuenta de destino en tu perfil web.'
        },
        {
          id: 7, title: 'EE. UU',
          banks: [{id: 1, name: 'Bank of America (Bofa)'}, {id: 2, name: 'Wells Fargo'}],
          observation: 'Al agregar la cuenta de destino debes ingresar el  routing number en el campo llamado “Número ABA”. El routing number o número de enrutamiento es de 9 dígitos y se usa en conjunto con el número de cuenta bancaria para realizar transferencias bancarias.'
        },
        {
          id: 8, title: 'Perú',
          banks: [{id: 1, name: 'BCP'}, {id: 2, name: 'Scotiabank'}, {id: 3, name: 'Interbank'}, {id: 4, name: 'BBVA'}],
          observation: 'Al agregar la cuenta de destino en tu perfil web, debes ingresar el Nº de cuenta simple en el campo llamado “Número de cuenta”, y en el campo llamado “Datos adicionales”, debes ingresar el CCI (Código de Cuenta Interbancario) de la cuenta bancaria el cual es de 20 dígitos.'
        },
        {
          id: 9, title: 'Chile',
          banks: [{id: 1, name: 'Todos los bancos.'}],
          observation: 'Al agregar la cuenta de destino en tu perfil web, debes ingresar el RUT del destinatario en el campo llamado “Número de identificación”.'
        },
        {
          id: 10, title: 'Cripto wallets',
          banks: [{id: 1, name: 'TRC20'}, {id: 2, name: 'ERC20'}],
          observation: 'Las transferencias de dólares tether (USDT) a billeteras ERC20 tienen una comisión de hasta 30 USDT, mientras que a billeteras TRC20 la comisión es de 2,5 USDT, las cuales son cobradas por la RED y no por Arcadi. Para que la comisión sea de $0 USDT, la billetera de destino debe ser de Binance, en cuyo caso lo mínimo que puedes enviar a una billetera TRC20 es 10 USDT, y a una billetera ERC20, 50 USDT.'
        },
        {
          id: 11, title: 'Cripto wallets',
          banks: [{id: 1, name: 'TRC20'}, {id: 2, name: 'ERC20'}],
          observation: 'Las transferencias de USD Coin (USDC) a billeteras ERC20 tienen una comisión de hasta 30 USDC, mientras que a billeteras TRC20 la comisión es de 2,5 USDC, las cuales son cobradas por la RED y no por Arcadi. Para que la comisión sea de $0 USDC, la billetera de destino debe ser de Binance, en cuyo caso lo mínimo que puedes enviar a una billetera TRC20 es 10 USDC, y a una billetera ERC20, 50 USDC.'
        },
      ]
    }
  },
  watch: {
    // Escape y Tab se escuchan en document mientras el modal está abierto. En el
    // velo no alcanzaba: al tocar un texto del modal el foco pasa a <body>, que
    // queda fuera del velo, y entonces Escape no cerraba y Tab sacaba el foco a
    // la página de atrás.
    show: {
      immediate: true,
      handler(abierto) {
        if (abierto) {
          document.addEventListener('keydown', this.handleDocumentKeydown);
        } else {
          document.removeEventListener('keydown', this.handleDocumentKeydown);
        }
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleDocumentKeydown);
  },
  methods: {
    handleDocumentKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.$emit('close');
      } else if (event.key === 'Tab') {
        // Una sola acción (cerrar): Tab y Shift+Tab dejan, o devuelven, el foco
        // en el botón de cerrar.
        event.preventDefault();
        if (this.$refs.close) this.$refs.close.focus();
      }
    },
    getTitle(countryId){
      const country = this.countries.filter((item) => {
        return (item.id == countryId)
      })
      return country.length > 0 ? country[0].title : "";
    },
    getBanks(countryId){
      const country = this.countries.filter((item) => {
        return (item.id == countryId)
      })
      return country.length > 0 ? country[0].banks : [];
    },
    getObservation(countryId){
      const country = this.countries.filter((item) => {
        return (item.id == countryId)
      })
      return country.length > 0 ? country[0].observation : "";
    },
  },
}
</script>

<template>
  <!-- The destination dialog shares the user-modal visual contract. Its parent
       teleports it to body; Escape, backdrop and the existing focus trap are
       unchanged. -->
  <Transition name="tpaga-billetera-modal">
    <div
      v-if="show"
      class="tpaga-billetera-modal user-modal__backdrop"
      @click.self="$emit('close')"
    >
      <div
        class="tpaga-billetera-modal__card user-modal__panel user-modal__body"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tpaga-billetera-modal-titulo"
      >
        <button
          ref="close"
          type="button"
          class="tpaga-billetera-modal__close user-modal__close"
          aria-label="Cerrar"
          @click="$emit('close')"
        >
          <span class="material-icons-sharp" aria-hidden="true">cancel</span>
        </button>

        <div class="tpaga-billetera-modal__head">
          <img v-if="countryPath" :src="countryPath" alt="" class="tpaga-billetera-modal__bandera" />
          <div>
            <p class="tpaga-billetera-modal__eyebrow">Destino</p>
            <h2 id="tpaga-billetera-modal-titulo" class="tpaga-billetera-modal__title user-modal__title">{{ getTitle(idCountry) }}</h2>
          </div>
        </div>

        <section v-if="getBanks(idCountry).length" class="tpaga-billetera-modal__section">
          <h3 class="tpaga-billetera-modal__subtitle">Bancos disponibles</h3>
          <ul class="tpaga-billetera-modal__bancos">
            <li v-for="(bank) of getBanks(idCountry)" :key="bank.id" class="tpaga-pill">
              {{ bank.name }}
            </li>
          </ul>
        </section>

        <section v-if="getObservation(idCountry)" class="tpaga-billetera-modal__section">
          <h3 class="tpaga-billetera-modal__subtitle">Observaciones</h3>
          <p class="tpaga-billetera-modal__texto user-modal__body">{{ getObservation(idCountry) }}</p>
        </section>

        <p
          v-if="!getBanks(idCountry).length && !getObservation(idCountry)"
          class="tpaga-billetera-modal__texto user-modal__body"
        >
          No tenemos información adicional para este destino.
        </p>
      </div>
    </div>
  </Transition>
</template>
